/* Rucan Games storefront interactions v2. Everything here is progressive: the page works without it. */
(function () {
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bound = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function once(el) { if (!bound) return true; if (bound.has(el)) return false; bound.add(el); return true; }

  /* cursor glow: one fixed layer moved with transform (no page-wide style recalcs) */
  if (fine && !still) {
    var glow = document.createElement('div'); glow.className = 'rg-cursor'; glow.setAttribute('aria-hidden', 'true');
    document.body.appendChild(glow);
    var gx = innerWidth / 2, gy = innerHeight / 3, queued = false;
    window.addEventListener('pointermove', function (e) {
      gx = e.clientX; gy = e.clientY;
      if (!queued) { queued = true; requestAnimationFrame(function () { glow.style.transform = 'translate3d(' + gx + 'px,' + gy + 'px,0)'; queued = false; }); }
    }, { passive: true });
  }

  function tilt(el, max) {
    var g = el.querySelector(':scope > .rg-glare');
    if (!g) { g = document.createElement('span'); g.className = 'rg-glare'; el.appendChild(g); }
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      el.style.transition = 'transform .15s ease-out, border-color .3s, box-shadow .5s';
      el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * max) + 'deg) rotateY(' + ((x - 0.5) * max) + 'deg) translateY(-6px)';
      g.style.setProperty('--gx', x * 100 + '%'); g.style.setProperty('--gy', y * 100 + '%');
    });
    el.addEventListener('pointerleave', function () { el.style.transition = ''; el.style.transform = ''; });
  }

  function reveal() {
    if (!('IntersectionObserver' in window) || still) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.remove('rg-pre'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('.rg-rv').forEach(function (el, i) {
      if (!once(el)) return;
      if (el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('rg-pre'); el.style.transitionDelay = (i % 4) * 60 + 'ms'; io.observe(el);
      }
    });
  }

  function desktopOnly() {
    if (!fine || still) return;
    document.querySelectorAll('.rg-tc, .card-wrapper').forEach(function (el) {
      if (!once(el)) return;
      tilt(el, el.classList.contains('rg-prod') || el.classList.contains('card-wrapper') ? 3 : 8);
    });
    document.querySelectorAll('.rg-btn').forEach(function (b) {
      if (!once(b)) return;
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.12) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.2 - 2) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* desktop: open header dropdowns on hover (click still works) */
  function hoverMenus() {
    if (!fine) return;
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      if (!once(d)) return;
      var t;
      d.addEventListener('mouseenter', function () { clearTimeout(t); d.setAttribute('open', ''); var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'true'); });
      d.addEventListener('mouseleave', function () { t = setTimeout(function () { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false'); }, 120); });
    });
  }

  /* ajax add-to-cart + toast for homepage tiles */
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var toast;
  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div'); toast.className = 'rg-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span></span><a href="' + cartUrl + '">View cart</a>';
      document.body.appendChild(toast);
    }
    toast.firstChild.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3800);
  }
  function refreshCartBubble() {
    fetch(cartUrl + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.shopify-section');
      var target = document.getElementById('cart-icon-bubble');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form.rg-add-form') : null;
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.rg-add');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        btn.classList.add('rg-ok'); btn.setAttribute('aria-label', 'Added to cart');
        showToast('Added: ' + (item.product_title || 'item'));
        refreshCartBubble();
        setTimeout(function () { btn.classList.remove('rg-ok'); btn.setAttribute('aria-label', 'Add to cart'); btn.disabled = false; }, 1400);
      })
      .catch(function (err) {
        btn.disabled = false;
        showToast((err && err.description) || 'Could not add to cart');
      });
  });

  function init() { reveal(); desktopOnly(); hoverMenus(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  /* product tabs build their other panels on demand: wire up the new tiles too */
  document.addEventListener('rg:hydrated', init);
})();